import React from "react";
import { BlockTitle } from "../../../../common/components";
import { translate } from "../../../../common/providers";
import ProjectsListTable from "./projects-list-table/ProjectsListTable";

export default function ProjectsList({
	isCanvas = false,
	onAddPartner,
	onAddUser,
	onClickRow,
	onChangeArchive,
	onDownload,
	onRelaunchDocs,
	onResetElastic,
	projectsRequest,
}) {
	return (
		<>
			<BlockTitle>{translate("dsi.project-list.title")}</BlockTitle>
			<ProjectsListTable
				isCanvas={isCanvas}
				projectsRequest={projectsRequest}
				onAddPartner={onAddPartner}
				onAddUser={onAddUser}
				onChangeArchive={onChangeArchive}
				onDownload={onDownload}
				onRelaunchDocs={onRelaunchDocs}
				onResetElastic={onResetElastic}
				onSelectRow={onClickRow}
			/>
		</>
	);
}
